<template>
  <div id="app">
    <div class="body fixed mobile">
      <section class="header store_register">
        <div class="flexH width">
          <a
            class="icon iconButton third"
            @click.prevent="$router.push('/setting')"
          >
            <font-awesome-icon icon="fa-solid fa-chevron-left" size="lg" />
          </a>
        </div>
        <span class="fL nowrap">刪除帳號</span>
        <div class="flexH width right"></div>
      </section>
      <div class="main bg-white">
        <div class="mt-8 mb-4 text-center">
          <div class="mt-8 mb-4">
            <img src="@/assets/icon/avatar-notfound.svg" width="147" height="159" alt="刪除提醒" class="mb-2" />
          </div>

          <h3 class="mb-4">刪除帳號提醒</h3>

          <p>
            <span class="error">同一手機號碼30天內無法重新註冊</span>
            <br />
            確定要刪除帳號嗎？
          </p>
        </div>

        <div class="mt-auto px-6">
          <button type="button" class="button border rounded w-100 fM mb-4" @click="() => $router.push('/setting')">取消</button>
          <button type="button" class="button rounded w-100 fM" @click="clickRemoveAccount"><span>仍要刪除帳號</span></button>
        </div>
      </div>
    </div>

    <ConfirmDialog
      ref="removeAccountDialogRef"
      :type="removeAccountDialogInfo.type"
      :title="removeAccountDialogInfo.title"
      :content="removeAccountDialogInfo.content"
      :buttons="removeAccountDialogInfo.buttons"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import ConfirmDialog from "@/components/Dialog/ConfirmDialog.vue";

export default {
  name: "SettingDeleteAccount",
  components: {
    ConfirmDialog
  },
  data() {
    return {
      apiHost: process.env.VUE_APP_API_HOST,
      appHost: process.env.VUE_APP_HOST + process.env.BASE_URL,
      showDialog: false,
      link: '',
    };
  },
  mounted() {
    if (sessionStorage.getItem('reloadAlert') === 'true') {
      // 顯示 alert
      this.showDialog = true;
      
      // 移除標記，防止後續的頁面重新加載還觸發 alert
      sessionStorage.removeItem('reloadAlert');
    }
  },
  computed: {
    ...mapState(["user"]),
    removeAccountDialogInfo() {
      return {
        type: "info",
        title: "刪除帳號",
        content: "帳號刪除後將立即生效，確定要刪除嗎？",
        buttons: [
          {
            text: "取消",
            outline: true,
            click: ({ close }) => {
              close();
            },
          },
          {
            text: "確定",
            click: ({ close }) => {
              close();
              this.removeAccount()
            },
          },
        ],
      }
    }
  },
  methods: {
    logout() {
      qcsso
        .logout({
          logoutRedirectUri: this.appHost.substring(0, this.appHost.length - 1),
        })
        .then(() => {
          window.Yunlin?.postMessage(JSON.stringify({ type: "logout" }))
          window.flutter_inappwebview?.callHandler('Yunlin', JSON.stringify({ type: "logout" }));
        })
        .catch((err) => console.log(err)).finally(() => {
          console.log("JS Interface", { type: "logout" })
        });
    },
    clickRemoveAccount() {
      this.$refs.removeAccountDialogRef.open();
    },
    async removeAccount() {
      try {
        await this.removeAccountApi();
        this.logout();
      } catch (error) {
        console.log('error', error);
      }
    },
    async removeAccountApi() {
      await this.$http({
        url: `${this.apiHost}/identities/v1/merchants/yunlin/members/${this.user.userId}`,
        method: "DELETE",
      });
    }
  }
};
</script>

<style scoped>
  .main {
    > div.flex {
      height: 100%;
    }
  }
</style>